export const APP_CONFIG = {
    appName: 'Gastro Health',
    frontend: 'https://gastrohealthbenefits.com',
    apiHash: 'https://gastrohealthbenefits.com/api/1.0',
    api: '/api/2.0',
    trustModel: false,
    authHeaders: {
        xServiceProvider: 'gastrohealth-prod-frontend',
        'tenant-id': '7afa5ce6-6299-4f4d-9424-38b3f510144b',
        'consumer-id': '127b7722-3f8b-4566-9590-7b4cb35ef9fb',
    },
    provider: 'gastrohealth-prod-frontend',
    colors: {
        primary: '#223b61',
        secondary: '#00afec',
    },
    multilingual: false,
    demoMode: false,
    contactEnabled: true,
    chatEnabled: false,
    isDarkModeEnabled: false,
    gtm: 'GTM-57HSPW9L',
    copyright: '<small>&copy; ' + new Date().getFullYear() +
        ' Gallagher | All Rights Reserved. Powered by Core.' + '</small>',
    navigation: {
        navType: 'top', // 'top' or 'side' (default is 'top' if empty or null)
        collapsibleSidenav: false, // Only used for sidenav
        headerStyle: 'solid', // 'solid' or 'transparent'
        categoryNav: true // true or false
    },
    domainsToZones: [
        {domain: 'alabama.gastrohealthbenefits.com', zone: '2'}
    ],
    imagery: {
        logo: 'https://storage.googleapis.com/bedrocc/GastroHealthLogoStackedRGB.png',
        logoInverted: 'https://storage.googleapis.com/bedrocc/GastroHealthLogoStackedRGB.png',
        logoTransparent: 'https://storage.googleapis.com/bedrocc/GastroHealthLogoStackedRGB.png',
    },
    benefitPIDS: [2, 65],
    coreLinkify: true,
    enableSSR: false,
    cookiePolicy: '9f173c61',
};

